<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Operazione </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaModifiche" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row align="center" justify="center">
          <!-- Input del codice operazione -->
          <v-col align="center" cols="4">
            <v-text-field
              label="Cod. Operazione"
              v-model="operazione_sel.cod_operazione"
            ></v-text-field>
          </v-col>

          <!-- Input della descrizione operazione -->
          <v-col align="center" cols="4">
            <v-text-field
              label="Des. Operazione"
              v-model="operazione_sel.des_operazione"
            ></v-text-field>
          </v-col>

          <!-- Input del tipo operazione -->
          <v-col align="center" cols="4">
            <v-autocomplete
              @change="assignDesOperazione"
              :items="items_tipo_operazione"
              item-text="des"
              item-value="id_tabella"
              label="Tipo Operazione"
              v-model="operazione_sel.tipo_operazione"
            >
              <template #label>
                <span class="">Tipo Operazione</span>
                <span @click.stop style="min-width: 500px; pointer-events: all">
                  <Modules
                    v-on:dialogModules="getTabella"
                    tipo="TIPO_OPERAZIONE_QUERY"
                    nome="Tipo Operazione"
                    setaction="settabelle"
                    getaction="gettabelle"
                    controller="Magazzino"
                    :filter="'validita = 1'"
                    :dati="[{ des: '' }]"
                  />
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- <v-row align="center" justify="start">
          <v-col align="center" cols="8">
            <v-autocomplete
              dense
              hide-details
              :items="items_btn"
              item-text="tooltip"
              item-value="fields"
              label="Bottoni Associati"
              multiple
              v-model="operazione_sel.pulsanti"
            ></v-autocomplete>
          </v-col>
        </v-row> -->

        <!-- Spazio per la query -->
        <!-- <v-row align="center" justify="center">
          <v-col align="center" cols="12">
            <QueryEditor :template="[]" v-model="operazione_sel" />
          </v-col>
        </v-row> -->
      </v-container>
    </v-card-text>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
// import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
// import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Operazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "abilitazione", default_val: 0, complex: false },
      { nome: "cod_operazione", default_val: "", complex: false },
      { nome: "des_operazione", default_val: "", complex: false },
      { nome: "des_tipo", default_val: "", complex: false },
      { nome: "id_operazione", default_val: -1, complex: false },
      // { nome: "id_operazione_tmp", default_val: -moment().valueOf(), complex: false },
      { nome: "id_operazione_abilitazione", default_val: -1, complex: false },
      // { nome: "pulsanti", default_val: [], complex: true },
      // { nome: "ST-ST", default_val: 0, complex: false },
      // { nome: "AVPACK", default_val: 0, complex: false },
      // { nome: "SUBENTRO", default_val: 0, complex: false },
      // { nome: "REGPZ", default_val: 0, complex: false },
      // { nome: "VDIS", default_val: 0, complex: false },
      // { nome: "LOTTI", default_val: 0, complex: false },
      // { nome: "CONTROLLO", default_val: 0, complex: false },
      // { nome: "FASENOTE", default_val: 0, complex: false },
      // { nome: "SPACK", default_val: 0, complex: false },
      // { nome: "COMNOTE", default_val: 0, complex: false },
      // { nome: "CQUALITA", default_val: 0, complex: false },
      // { nome: "ALLEGATO", default_val: 0, complex: false },
      // { nome: "ISTR", default_val: 0, complex: false },
      // { nome: "AMWO", default_val: 0, complex: false },
      // { nome: "NWO", default_val: 0, complex: false },
      // { nome: "LISTA", default_val: 0, complex: false },
      // { nome: "REGALT", default_val: 0, complex: false },
      // { nome: "LAVTEAM", default_val: 0, complex: false },
      // { nome: "IPP", default_val: 0, complex: false },
      // { nome: "PRTETICH", default_val: 0, complex: false },
      // { nome: "REGIMB", default_val: 0, complex: false },
      // { nome: "CHECK", default_val: 0, complex: false },
      // { nome: "VBAS", default_val: 0, complex: false },
      // { nome: "RILTMP", default_val: 0, complex: false },
      // { nome: "DICSCARTI", default_val: 0, complex: false },
      // { nome: "SIGNAL", default_val: 0, complex: false },
      // { nome: "XXXX", default_val: 0, complex: false },

      { nome: "query", default_val: "", complex: false },
      { nome: "riferimento", default_val: null, complex: false },
      { nome: "tipo_operazione", default_val: null, complex: false },
      { nome: "tipo_riferimento", default_val: "", complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "ModificaOperazione",
  components: {
    Modules: () => import("../../components/TOOLS/Modules"),
    // QueryEditor,
    SnackbarQV,
  },
  props: {
    items_btn: {
      type: Array,
      default: () => [],
    },
    operazione: {
      type: Object,
      default: () => {},
    },
    riferimento: { type: Number, default: null },
    tipo_riferimento: { type: String, default: "" },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      operazione_sel: new Operazione(),

      // Modal
      overlay: false,

      // Array
      items_tipo_operazione: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.operazione_sel = new Operazione(this.operazione);
        }
      },
    },
  },
  methods: {
    assignDesOperazione() {
      this.items_tipo_operazione.forEach((t) => {
        if (t.id_tabella === this.operazione_sel.tipo_operazione) {
          this.operazione_sel.des_tipo = t.des;
        }
      });
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    getTabella() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_OPERAZIONE_QUERY",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.items_tipo_operazione = res.data;
        }
      });
    },
    salvaModifiche() {
      // console.log("new operazione =>", this.operazione_sel);
      // this.$emit("add_operation", this.operazione_sel);


      const obj_tmp = this.operazione_sel;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setoperazionifull",
          token: localStorage.user_token,
          operazioni_abilitazioni: [obj_tmp],
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.overlay = false;
          this.$emit("get_operazioni");

          // Preparo l'array di operazioni-abilitazioni da salvare.
          // const arr_tmp = new Array();

          // obj_tmp.pulsanti.forEach((p) => {
          //   arr_tmp.push({
          //     fields: p.fields,
          //     id_operazione: obj_tmp.id_operazione,
          //     /* Se l'associazione a un pulsante esisteva già,
          //      * prendo quell'id_operazione_abilitazione altrimenti
          //      * lo imposto a -1 perché è nuovo. */
          //     id_operazione_abilitazione:
          //       this.operazione.pulsanti.filter((po) => {
          //         po.fields == p;
          //       }).length > 0
          //         ? this.operazione.pulsanti.filter((po) => {
          //             po.fields == p;
          //           })[0].id_operazione_abilitazione
          //         : -1,
          //     riferimento: obj_tmp.riferimento,
          //     tipo_riferimento: obj_tmp.tipo_riferimento,
          //     validita: obj_tmp.validita,
          //   });
          // });

          // if (res.status === 200) {
          //   const request2 = {
          //     controller: "Magazzino",
          //     method: "PUT",
          //     richiesta: {
          //       action: "setoperazioniabilitazioni",
          //       token: localStorage.user_token,
          //       tabella: arr_tmp,
          //     },
          //   };

          //   this.overlay = true;
          //   this.$store
          //     .dispatch("api", request2)
          //     .then((res2) => {
          //       this.overlay = false;
          //       if (res2.status === 200) {
          //         this.conferma_elimina_operazione = false;
          //         this.$emit("salvata_operazione");
          //       } else {
          //         this.$refs.SnackbarQV.print(
          //           "orange",
          //           "Errore di comunicazione col server, non è stato possibile salvare i fati."
          //         );
          //       }
          //     })
          //     .catch((e2) => {
          //       this.overlay = false;
          //       console.error(e2);
          //       this.$refs.SnackbarQV.print(
          //         "error",
          //         "Errore di comunicazione col server, non è stato possibile salvare i fati."
          //       );
          //     });
          // } else {
          //   this.$refs.SnackbarQV.print(
          //     "orange",
          //     "Errore di comunicazione col server, non è stato possibile salvare i fati."
          //   );
          // }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i fati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getTabella();
  },
};
</script>
<style scoped>
</style>